type Props = {
  /** Que arquivo entra neste slot, em uma linha. */
  spec: string;
  tone?: 'light' | 'dark';
  /** Fora de uma moldura de mídia, como legenda abaixo do bloco. */
  inline?: boolean;
};

/**
 * Slot ainda sem mídia. Nunca finge ser a entrega: diz o que falta e some
 * assim que o manifesto em `src/data/portfolio-examples.ts` receber a URL.
 */
export default function EmptyMediaSlot({ spec, tone = 'dark', inline = false }: Props) {
  return (
    <div className={`ex-empty ex-empty--${tone}${inline ? ' ex-empty--inline' : ''}`}>
      <span className="ex-empty__title">Mídia entra aqui</span>
      <span className="ex-empty__spec">{spec}</span>
    </div>
  );
}
